module.exports = __webpack_public_path__ + "static/img_1761-acfac7a5d0d8a8ac1ea1514bf7c57981.webp";